import { ICondition } from "../../core/src/states/State";
import GameModel from "../../core/src/model/GameModel";
import SpinModel from "../../core/src/model/SpinModel";

export default class HasRecovery implements ICondition {
    check(): boolean {
        // console.log((GameModel.restoreData != null || GameModel.restoreData != undefined )
        // && (SpinModel.generations > GameModel.restoreData.generation || SpinModel.hasWinnings()));

        // TODO: fix this! Or do not commit
        return false;

        return (
            (GameModel.restoreData != null ||
                GameModel.restoreData != undefined) &&
            (SpinModel.generations > GameModel.restoreData.generation ||
                SpinModel.hasWinnings())
        );
    }
}
